exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row-custom {\n.col {\n\t\tflex: 0 0 20%;\n\t\tmax-width: 20%;\n}\n.break {\n\t\tflex-basis: 0;\n\t\tflex-grow: 1;\n\t\tmax-width: 40%;\n}\n}\n.order-1 {\n\torder: 1;\n}\n.order-2 {\n\torder: 2;\n}\n", ""]);

// exports
